import { useFormContext, useWatch } from 'react-hook-form'
import CategoryInput from '../../common/CategoryInput'
import { ENTITY_NAME, NAMESPACES } from '../../../utils/constants'
import { FIELD_VALUE_CONSTANTS } from '@ui-kit'
import { isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'
import {
  HybridLayoutDefaultFieldPropsType,
  HybridLayoutDefaultFieldViewValPropsType,
} from '../hybridLayout.types'
import { DropdownType } from '@app-store'
import { useAppSelector } from '../../../utils/agent.store'
import { useFormBehaviorFieldOverrides } from '../../../form-behavior/useFormBehaviorFieldOverrides'

const HybridLayoutFieldCategoryFieldViewVal: React.FC<
  HybridLayoutDefaultFieldViewValPropsType
> = ({ element }) => {
  const catageoryValue = useAppSelector(
    (state) => state.categoryDropdown?.categoryMap
  )
  const valWatch = useWatch({ name: element?.keyName })
  const [val, setVal] = useState<string>('--')
  useEffect(() => {
    if (!valWatch?.id) {
      return
    }
    const catVal = catageoryValue?.[
      element.meta.filter_criteria?.category_type ?? ''
    ]?.find((cat) => cat?.id === valWatch?.id)
    setVal(catVal?.value ?? '--')
  }, [catageoryValue, valWatch])
  return <div className="text-xs font-extraLight">{val}</div>
}

export const HybridLayoutFieldCategoryField: React.FC<HybridLayoutDefaultFieldPropsType> =
  React.memo(({ element, entityName, mode, fullLayout }) => {
    const {
      control,
      setValue,
      formState: { errors },
    } = useFormContext()

    const baseDisabled = !isEmpty(element?.parent) || !!element?.isDisabled
    const {
      effectiveDisabled,
      effectiveRequired,
      effectiveHidden,
      behaviorCategoryFilter,
      triggerFieldChange,
    } = useFormBehaviorFieldOverrides(
      fullLayout,
      element,
      baseDisabled,
      element?.meta?.required
    )

    if (effectiveHidden) {
      return null
    }

    return (
      <div>
        {mode === 'view' ? (
          <div className="font-primary font-light">
            <label
              htmlFor={element?.keyName}
              className="text-sm font-normal mb-1 block"
            >
              {element?.meta?.label}
            </label>
            <div className="text-xs font-extraLight">
              <HybridLayoutFieldCategoryFieldViewVal element={element} />
            </div>
          </div>
        ) : (
          <CategoryInput
            name={element.keyName}
            label={element.meta.label}
            control={control}
            isSearchable={true}
            onChange={(e: DropdownType<string>) => {
              setValue(element.keyName, e?.value)
              triggerFieldChange()
            }}
            setValue={setValue}
            required={effectiveRequired}
            disabled={effectiveDisabled}
            // hasPermission={hasPermission}
            categoryKey={element.meta.filter_criteria?.category_type ?? ''}
            behaviorCategoryFilter={behaviorCategoryFilter}
            searchLength={
              [
                ENTITY_NAME.PATIENTS,
                ENTITY_NAME.PROVDERS,
                ENTITY_NAME.CONTACTS,
              ]?.includes(entityName || '') &&
              element?.keyName === NAMESPACES.SUFFIX
                ? FIELD_VALUE_CONSTANTS.ONE
                : FIELD_VALUE_CONSTANTS.THREE
            }
            dataQaId={element.keyName ?? ''}
            errors={errors}
          />
        )}
      </div>
    )
  })
HybridLayoutFieldCategoryField.displayName = 'HybridLayoutFieldCategoryField'
